// extracted by mini-css-extract-plugin
export default {"select":"CompanyLocationSelects_select__CoeZb","text":"CompanyLocationSelects_text__gDe4J","company":"CompanyLocationSelects_company__Rw9wR"};